import { useState } from "react";
import { Link } from "react-router-dom";

const STATS = [["pts", "Points"], ["reb", "Rebounds"], ["ast", "Assists"], ["stl", "Steals"], ["blk", "Blocks"]];
const CONFS = [["Eastern Conference", "east"], ["Western Conference", "west"]];
const day = (iso) => new Date(iso).toLocaleDateString("en-GB", { timeZone: "America/New_York", day: "numeric", month: "short" });
const ago = (iso) => {
  const h = Math.max(0, Math.round((Date.now() - new Date(iso)) / 36e5));
  return h < 1 ? "now" : h < 24 ? `${h}h ago` : `${Math.round(h / 24)}d ago`;
};

function Leaders({ leaders }) {
  const [stat, setStat] = useState("pts");
  return (
    <section className="ncs-card" data-testid="standings-leaders">
      <h3>CONFERENCE LEADERS</h3>
      <div className="ncs-seg">
        {STATS.map(([k, t]) => <button key={k} type="button" className={stat === k ? "active" : ""} onClick={() => setStat(k)} data-testid={`leaders-tab-${k}`}>{t}</button>)}
      </div>
      <div className="ncs-leaders">
        {CONFS.map(([conf, id]) => (
          <div key={id} data-testid={`leaders-${id}`}>
            <h4>{conf.split(" ")[0]}</h4>
            {(leaders?.[stat]?.[conf] || []).map((p, i) => (
              <Link key={p.player_id} to={`/player/${p.player_id}`} className="ncs-leader" data-testid={`leader-${id}-${i}`}>
                <b>{i + 1}</b>
                <img src={p.photo} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.visibility = "hidden"; }} />
                <span><strong>{p.name}</strong><small>{p.team}</small></span>
                <em>{p.value.toFixed(1)}</em>
              </Link>
            ))}
            {!(leaders?.[stat]?.[conf] || []).length && <p className="ncs-muted">No games yet.</p>}
          </div>
        ))}
      </div>
    </section>
  );
}

function Recent({ games }) {
  const [conf, setConf] = useState("all");
  const list = games.filter((g) => conf === "all" || g.conferences.includes(conf)).slice(0, 8);
  return (
    <section className="ncs-card" data-testid="standings-recent">
      <h3>RECENT GAMES</h3>
      <div className="ncs-seg">
        {[["all", "All"], ["Eastern Conference", "Eastern"], ["Western Conference", "Western"]].map(([k, t]) => (
          <button key={k} type="button" className={conf === k ? "active" : ""} onClick={() => setConf(k)} data-testid={`recent-filter-${t.toLowerCase()}`}>{t}</button>
        ))}
      </div>
      {list.map((g) => {
        const awayWin = g.away_pts > g.home_pts;
        return (
          <div key={g.id} className="ncs-game" data-testid={`recent-game-${g.id}`}>
            <small>{day(g.date_utc)}</small>
            <Link to={`/teams/${g.away_team_id}`} className={awayWin ? "w" : ""}><img src={g.away.logo} alt="" />{g.away.code}</Link>
            <b><i className={awayWin ? "w" : ""}>{g.away_pts}</i> - <i className={awayWin ? "" : "w"}>{g.home_pts}</i></b>
            <Link to={`/teams/${g.home_team_id}`} className={awayWin ? "" : "w"}>{g.home.code}<img src={g.home.logo} alt="" /></Link>
          </div>
        );
      })}
      {!list.length && <p className="ncs-muted">No finished games.</p>}
    </section>
  );
}

function News({ news }) {
  return (
    <section className="ncs-card" data-testid="standings-news">
      <h3>LATEST NEWS</h3>
      {news.slice(0, 5).map((n, i) => (
        <a key={i} href={n.link} target="_blank" rel="noreferrer" className="ncs-news" data-testid={`news-item-${i}`}>
          {n.image && <img src={n.image} alt="" loading="lazy" />}
          <span><strong>{n.headline}</strong>{n.description && <small>{n.description}</small>}<em>{ago(n.published)} | ESPN</em></span>
        </a>
      ))}
    </section>
  );
}

export function StandingsSidebar({ data }) {
  return (
    <aside className="ncs-sidebar" data-testid="standings-sidebar">
      <Leaders leaders={data.leaders} />
      {data.recent.length > 0 && <Recent games={data.recent} />}
      {data.news.length > 0 && <News news={data.news} />}
    </aside>
  );
}
